module.exports = __webpack_public_path__ + "static/media/portfolio_something_wrong.f14c1600.svg";